/// <amd-module name="Build/Admin/Common/Actions/NotificationActionCreator" />
import { NotificationActions } from "Build/Admin/Common/Actions/NotificationActions";
import { INotification, NotificationType } from "Build/Admin/Common/Stores/NotificationStore";

import { IButtonProps } from "VSSUI/Button";

export interface INotificationActionCreatorOptions {
    notificationActions: NotificationActions;
}

export class NotificationActionCreator {
    private _notificationActions: NotificationActions;

    constructor(options: INotificationActionCreatorOptions) {
        this._notificationActions = options.notificationActions;
    }

    public addNotification(message: string, notificationType: NotificationType, buttonProps?: IButtonProps[]): void {
        this._notificationActions.addNotification.invoke({ notificationType, message, buttonProps });
    }

    public dismissNotification(notification: INotification): void {
        this._notificationActions.dismissNotification.invoke(notification);
    }

    public clearNotifications(): void {
        this._notificationActions.clearNotifications.invoke(undefined);
    }
}
